import igs01 from './igs-01'
import igs01se from './igs-01se'
import igs02 from './igs-02'
import igs05 from './igs-05'
import igs06 from './igs-06'
import igs09 from './igs-09'
import igs10 from './igs-10'
import igs11 from './igs-11'
import igs12 from './igs-12'
import igs13 from './igs-13'
import igs14 from './igs-14'
import igs20 from './igs-20'
import igs20se from './igs-20se'
import igs25se from './igs-25se'
import igs27 from './igs-27'
import igs28se from './igs-28se'
import igs29 from './igs-29'
import igs36 from './igs-36'
import igs37se from './igs-37se'
import igs38 from './igs-38'
import igs39 from './igs-39'
import igs60 from './igs-60'
import igs70 from './igs-70'
import igs71 from './igs-71'

const list = [
  igs01,
  igs01se,
  igs02,
  igs05,
  igs06,
  igs09,
  igs10,
  igs11,
  igs12,
  igs13,
  igs14,
  igs20,
  igs20se,
  igs25se,
  igs27,
  igs28se,
  igs29,
  igs36,
  igs37se,
  igs38,
  igs39,
  igs60,
  igs70,
  igs71,
]
export default list
